module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-fill"
  }, [_c('div', {
    staticClass: "container py-3"
  }, [_c('div', {
    staticClass: "row justify-content-center h-100"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-8 d-flex flex-column"
  }, [_c('div', {
    staticClass: "mb-2 pointer",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": function($event) {
        return _vm.saveLastCustomerDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fas mr-1 fa-save light"
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "text-transform": "initial"
    }
  }, [_vm._v("Remember this info for future booking")])]), _vm._v(" "), _c('client-form', {
    staticClass: "flexGrow1 mb-3",
    attrs: {
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5,
      "customer": _vm.reservation.customer,
      "bookingComponents": _vm.reservation.bookingComponents,
      "transport": _vm.reservation.transport,
      "reservation": _vm.reservation
    },
    on: {
      "update:customer": function($event) {
        return _vm.$set(_vm.reservation, "customer", $event)
      },
      "phone-valid": _vm.onPhoneValid,
      "input": _vm.onChange
    }
  }), _vm._v(" "), _c('client-transport', {
    attrs: {
      "reservation": _vm.reservation,
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-4 mt-2 mt-lg-0"
  }, [_c('notes', {
    attrs: {
      "reservation": _vm.reservation,
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5
    }
  })], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-07c8ddbe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07c8ddbe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabCustomer/TabCustomer.vue
// module id = 1940
// module chunks = 0